import { render, staticRenderFns } from "./page.vue?vue&type=template&id=e31d9e5a&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=e31d9e5a&prod&lang=scss&scoped=true"
import style1 from "./page.vue?vue&type=style&index=1&id=e31d9e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31d9e5a",
  null
  
)

export default component.exports